import { useLanguage } from "@/contexts/LanguageContext";
import { Calendar, Clock, Video, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import AnimatedSection from "@/components/AnimatedSection";

const CALENDLY_URL = "https://calendly.com/eliott-sore-larregain/appel-30-min-localove";

const BookingCalendar = () => {
  const { language } = useLanguage();

  const features = [
    {
      icon: Calendar,
      label: language === "fr" ? "Choisissez votre créneau" : "Choose your slot",
    },
    {
      icon: Video,
      label: language === "fr" ? "Appel vidéo Microsoft Teams" : "Microsoft Teams video call",
    },
    {
      icon: Clock,
      label: language === "fr" ? "30 minutes" : "30 minutes",
    },
  ];

  return (
    <section id="booking" className="pt-12 lg:pt-16 pb-4 lg:pb-6 bg-slate-50/50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden border border-slate-200 bg-white shadow-lg">
            <div className="absolute inset-0 bg-gradient-to-br from-sky-50/30 via-transparent to-blue-50/30" />
            
            <div className="relative z-10 p-8 lg:p-10">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                <div className="flex-1">
                  <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sky-100 border border-sky-200 mb-4">
                    <Calendar className="w-4 h-4 text-sky-600" />
                    <span className="text-sm font-medium text-sky-700">
                      {language === "fr" ? "Réservation gratuite" : "Free booking"}
                    </span>
                  </div>
                  
                  <h2 className="text-2xl lg:text-3xl font-display font-bold text-slate-800 mb-3">
                    {language === "fr" ? "Réservez un " : "Book a "}
                    <span className="bg-gradient-to-r from-sky-400 via-blue-500 to-sky-400 bg-clip-text text-transparent animate-gradient-shine">
                      {language === "fr" ? "appel découverte" : "discovery call"}
                    </span>
                  </h2>
                  
                  <p className="text-slate-500 mb-4 max-w-lg">
                    {language === "fr" ? "Discutons de votre stratégie d'engagement client et découvrez comment Localove peut transformer votre commerce." : "Let's discuss your customer engagement strategy and discover how Localove can transform your business."}
                  </p>
                  
                  <div className="flex flex-wrap items-center gap-4 text-sm text-slate-600">
                    {features.map((feature, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <feature.icon className="w-4 h-4 text-sky-500" />
                        <span>{feature.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="flex-shrink-0">
                  <Button asChild size="lg" className="w-full lg:w-auto bg-gradient-to-r from-sky-500 to-blue-600 hover:from-sky-400 hover:to-blue-500 text-white font-semibold px-8 py-6 rounded-full shadow-xl shadow-sky-500/30 hover:shadow-sky-500/50 transition-all duration-300 hover:scale-105 hover:-translate-y-1 group animate-pulse-glow">
                    <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
                      {language === "fr" ? "Réserver maintenant" : "Book now"}
                      <ExternalLink className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                    </a>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingCalendar;
